import { type ReactElement, type ReactNode } from 'react';
import { useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '@/app/msal';

const RequireAuth = ({ children }: { readonly children: ReactNode }): ReactElement => {
  useMsalAuthentication(InteractionType.Redirect, loginRequest);
  return <>{children}</>;
};

export default RequireAuth;
